<template>
	<el-dialog title="共享环境加入管理" width="80%" :visible.sync="dialogTableVisible">
		<div class="titless">
			环境名称：{{form.title}}
		</div>
		<div class="titless">
			订单号：<span class="span">{{form.orderno}}</span>
		</div>
		<div class="titless">
			类型：{{form.typename}}
		</div>
		<div class="titless dsadsad">
			共享开发环境加入费用（元）：
			<div style="display: flex;margin-top: 10px;">
				<el-input placeholder="请输入价格" type="number" style="width: 70%;" v-model="form.gongMoney"></el-input>
			    <el-button @click="user_save_gongmoney" type="primary" style="background-color: #ff7600;border: #ff7600;margin-left: 10px;">确认填写</el-button>
			</div>
		</div>
		
				<el-table
				  v-loading="loading"
				  :data="list"
				  fit
				  :header-cell-style="{background:'#f5f5f5'}"
				  highlight-current-row
				  style="width: 100%;margin-top: 30px;"
				>
			  <el-table-column label="订单信息" show-overflow-tooltip align="left">
				<template slot-scope="scope">
				  <span class="span">订单号：{{scope.row.orderno}}</span>
				</template>
			  </el-table-column>
			  <el-table-column label="类型" width="80" show-overflow-tooltip align="left">
			    <template slot-scope="scope">
			      <span class="span">{{scope.row.type==1?'个人':'组织'}}</span>
			    </template>
			  </el-table-column>
			  <el-table-column label="总价" width="120" show-overflow-tooltip align="center">
			    <template slot-scope="scope">
			      <span class="span" style="color: red;">¥{{scope.row.money}}</span>
			    </template>
			  </el-table-column>
			  <el-table-column label="状态" width="120" show-overflow-tooltip align="center">
			    <template slot-scope="scope">
			    <span class="span">
				  {{scope.row.statusname}}
				</span>
			    </template>
			  </el-table-column>
			  <el-table-column label="操作" width="220" align="center">
			    <template slot-scope="scope">
				  <el-button type="text" size="mini" v-if='scope.row.status==1' @click="hancdsa(2,scope.row)">通过并创建Studio用户</el-button>
				  <el-button type="text" size="mini" v-if='scope.row.status==1' @click="jujue(scope.row.id,4)">
					  <span style="color: red;">
						  拒绝
					  </span>
				  </el-button>
			      <el-button type="text" size="mini" @click="xiangiqngs(scope.row)">查看详情</el-button>
			    </template>
			  </el-table-column>
		</el-table>
		<div class="pagination-container" style="margin-top: 20px;">
		  <el-pagination
		    :current-page="listquery.page"
		    :page-sizes="[5]"
		    :page-size="listquery.limit"
		    :total="total"
		    background layout="total, sizes, prev, pager, next, jumper"
		    @size-change="handleSizeChange"
		    @current-change="handleCurrentChange"
		  />
		</div>
		
		<!--共享订单加入详情-->
		<shenqingdetail ref="shenqingdetaildata" @sizzsa="admin_gongxiang_look"></shenqingdetail>
		<!--共享订单加入详情-->
		
		<!--通过并创建studio用户-->
		<studio ref="studiodata" @succss="admin_gongxiang_look"></studio>
		
	</el-dialog>
</template>

<script>
	import {user_save_gongmoney,admin_gongxiang_look,admin_shenhe_gong } from "@/api/huanjing"
	import shenqingdetail from "./shenqingdetail"
	import studio from "./studio"
	export default {
		components:{
			shenqingdetail,studio
		},
		data(){
			return{
				dialogTableVisible:false,
				form:{
					gongMoney:''
				},
				
				listquery:{
					page:1,
					limit:5,
					id:''
				},
				list:[],
				total:0,
				loading:false
			}
		},
		watch:{
			dialogTableVisible(e){
				if(e==false){
					this.listquery.page = 1
					this.list = [];
					this.total = 0
					this.form = {
						gongMoney:''
					}
					this.$emit("falses");
				}
			},
		},
		methods:{
			hancdsa(status,row){
				//console.log(row);return;
				this.$refs.studiodata.handle(status,row)
			},
			user_save_gongmoney(){
				if(!this.form.gongMoney){
					this.$message.error("共享开发环境加入费用不能为空");
					return;
				}
				const loading = this.$loading({
				          lock: true,
				          text: '提交中',
				          spinner: 'el-icon-loading',
				          background: 'rgba(0, 0, 0, 0.7)'
				        });
				user_save_gongmoney({
					id:this.form.huanjingid,
					gongMoney:this.form.gongMoney
				}).then(()=>{
					loading.close();
					this.$message.success("成功");
				}).catch(()=>{
					loading.close();
				})
			},
			xiangiqngs(row){
				console.log("查看详情",row);
				this.$refs.shenqingdetaildata.handlecreate(row.id,2323);
			},
			admin_gongxiang_look(){
				this.loading = true
				admin_gongxiang_look(this.listquery).then(res=>{
					this.loading = false
					console.log("申请列表",res.data);
					this.list = res.data.list
					this.total = res.data.total
				}).catch(()=>{
					this.loading = false
				})
			},
			jujue(id,status){
				this.$confirm('此操作将拒绝此条申请, 是否继续?', '提示', {
				  confirmButtonText: '确定',
				  cancelButtonText: '取消',
				  type: 'warning'
				}).then(()=>{
					const loading = this.$loading({
					  lock: true,
					  text: '拒绝中',
					  spinner: 'el-icon-loading',
					  background: 'rgba(0, 0, 0, 0.7)'
					});
					admin_shenhe_gong({
						id:id,
						status:status
					}).then(()=>{
						loading.close();
						this.$message.success("成功");
						this.admin_gongxiang_look();
					}).catch(()=>{
						loading.close();
					})
				})
			},
			//下一页上一页操作
			handleSizeChange(val) {//条数
			  this.listquery.limit = val
			  this.admin_gongxiang_look();
			},
			handleCurrentChange(val){
				this.listquery.page = val
				this.admin_gongxiang_look();
			},
			show(row){
				console.log("row",row);
				this.$nextTick(()=>{
					this.form = row
					this.dialogTableVisible = true
					this.listquery.id = row.huanjingid
					this.listquery.page = 1
					this.admin_gongxiang_look();
				})
			},
		},
	}
</script>

<style lang="scss" scope>
	.titless{
		width: 40%;
		padding-top: 15px;
		padding-bottom: 15px;
		border-bottom: 1px solid #cccccc;
		color: #333;
		font-size: 14px;
		font-weight: normal;
        .span{
			color: #ff7600;
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/luntan/neirong/components/gongadmin.vue